<template>
    <div>
        <v-expansion-panels v-model="panel" multiple>
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <div>
                        <p style=" margin-bottom: 9px;">Project Information</p>
                    </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content v-if="!loading">
                        <v-row>    
                            <v-col cols="12">
                                <v-divider></v-divider>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="2" class="mt-2 text-center">
                                <p>Year</p>
                            </v-col>
                            <v-col cols="10">
                                <v-text-field
                                    dense
                                    outlined
                                    label="Year"
                                    type="number"
                                    v-model="detailItems.year"
                                    hide-details
                                    color="grey-lighten-2" 
                                    :readonly="readonly"
                                    @change="DataChange"
                                    />
                            </v-col>
                        </v-row>
                        <v-row cols="12" no-gutters>    
                            <v-col cols="2">
                                <p class="mt-2 text-center">Month</p>
                            </v-col>
                            <v-col cols="5">
                                <p class="mt-2 text-center">%Plan</p>
                            </v-col>
                            <v-col cols="5">
                                <p class="mt-2 text-center">%Actual</p>
                            </v-col>
                        </v-row>
                        <v-row no-gutters>    
                            <v-col cols="2">
                                <p class="mt-2 text-center">JAN</p>
                            </v-col>
                            <v-col cols="5">
                                <v-text-field v-model="detailItems.plan_jan" dense outlined hide-details type="number" suffix="%" color="grey-lighten-2" :readonly="readonly" @change="DataChange" />
                            </v-col>
                            <v-col cols="5">
                                <v-text-field v-model="detailItems.actual_jan" dense outlined hide-details type="number" suffix="%" color="grey-lighten-2" :readonly="readonly" @change="DataChange" />
                            </v-col>
                        </v-row>
                        <v-row no-gutters>    
                            <v-col cols="2">
                                <p class="mt-2 text-center">FEB</p>
                            </v-col>
                            <v-col cols="5">
                                <v-text-field v-model="detailItems.plan_feb" dense outlined hide-details type="number" suffix="%" color="grey-lighten-2" :readonly="readonly" @change="DataChange" />
                            </v-col>
                            <v-col cols="5">
                                <v-text-field v-model="detailItems.actual_feb" dense outlined hide-details type="number" suffix="%" color="grey-lighten-2" :readonly="readonly" @change="DataChange" />
                            </v-col>
                        </v-row>
                        <v-row no-gutters>    
                            <v-col cols="2">
                                <p class="mt-2 text-center">MAR</p>
                            </v-col>
                            <v-col cols="5">
                                <v-text-field v-model="detailItems.plan_mar" dense outlined hide-details type="number" suffix="%" color="grey-lighten-2" :readonly="readonly" @change="DataChange" />
                            </v-col>
                            <v-col cols="5">
                                <v-text-field v-model="detailItems.actual_mar" dense outlined hide-details type="number" suffix="%" color="grey-lighten-2" :readonly="readonly" @change="DataChange" />
                            </v-col>
                        </v-row>
                        <v-row no-gutters>    
                            <v-col cols="2">
                                <p class="mt-2 text-center">APR</p>
                            </v-col>
                            <v-col cols="5">
                                <v-text-field v-model="detailItems.plan_apr" dense outlined hide-details type="number" suffix="%" color="grey-lighten-2" :readonly="readonly" @change="DataChange" />
                            </v-col>
                            <v-col cols="5">
                                <v-text-field v-model="detailItems.actual_apr" dense outlined hide-details type="number" suffix="%" color="grey-lighten-2" :readonly="readonly" @change="DataChange" />
                            </v-col>
                        </v-row>
                        <v-row no-gutters>    
                            <v-col cols="2">
                                <p class="mt-2 text-center">MAY</p>
                            </v-col>
                            <v-col cols="5">
                                <v-text-field v-model="detailItems.plan_may" dense outlined hide-details type="number" suffix="%" color="grey-lighten-2" :readonly="readonly" @change="DataChange" />
                            </v-col>
                            <v-col cols="5">
                                <v-text-field v-model="detailItems.actual_may" dense outlined hide-details type="number" suffix="%" color="grey-lighten-2" :readonly="readonly" @change="DataChange" />
                            </v-col>
                        </v-row>
                        <v-row no-gutters>    
                            <v-col cols="2">
                                <p class="mt-2 text-center">JUN</p>
                            </v-col>
                            <v-col cols="5">
                                <v-text-field v-model="detailItems.plan_jun" dense outlined hide-details type="number" suffix="%" color="grey-lighten-2" :readonly="readonly" @change="DataChange" />
                            </v-col>
                            <v-col cols="5">
                                <v-text-field v-model="detailItems.actual_jun" dense outlined hide-details type="number" suffix="%" color="grey-lighten-2" :readonly="readonly" @change="DataChange" />
                            </v-col>
                        </v-row>
                        <v-row no-gutters>    
                            <v-col cols="2">
                                <p class="mt-2 text-center">JUL</p>
                            </v-col>
                            <v-col cols="5">
                                <v-text-field v-model="detailItems.plan_jul" dense outlined hide-details type="number" suffix="%" color="grey-lighten-2" :readonly="readonly" @change="DataChange" />
                            </v-col>
                            <v-col cols="5">
                                <v-text-field v-model="detailItems.actual_jul" dense outlined hide-details type="number" suffix="%" color="grey-lighten-2" :readonly="readonly" @change="DataChange" />
                            </v-col>
                        </v-row>
                        <v-row no-gutters>    
                            <v-col cols="2">
                                <p class="mt-2 text-center">AUG</p>
                            </v-col>
                            <v-col cols="5">
                                <v-text-field v-model="detailItems.plan_aug" dense outlined hide-details type="number" suffix="%" color="grey-lighten-2" :readonly="readonly" @change="DataChange" />
                            </v-col>
                            <v-col cols="5">
                                <v-text-field v-model="detailItems.actual_aug" dense outlined hide-details type="number" suffix="%" color="grey-lighten-2" :readonly="readonly" @change="DataChange" />
                            </v-col>
                        </v-row>
                        <v-row no-gutters>    
                            <v-col cols="2">
                                <p class="mt-2 text-center">SEP</p>
                            </v-col>
                            <v-col cols="5">
                                <v-text-field v-model="detailItems.plan_sep" dense outlined hide-details type="number" suffix="%" color="grey-lighten-2" :readonly="readonly" @change="DataChange" />
                            </v-col>
                            <v-col cols="5">
                                <v-text-field v-model="detailItems.actual_sep" dense outlined hide-details type="number" suffix="%" color="grey-lighten-2" :readonly="readonly" @change="DataChange" />
                            </v-col>
                        </v-row>
                        <v-row no-gutters>    
                            <v-col cols="2">
                                <p class="mt-2 text-center">OCT</p>
                            </v-col>
                            <v-col cols="5">
                                <v-text-field v-model="detailItems.plan_oct" dense outlined hide-details type="number" suffix="%" color="grey-lighten-2" :readonly="readonly" @change="DataChange" />
                            </v-col>
                            <v-col cols="5">
                                <v-text-field v-model="detailItems.actual_oct" dense outlined hide-details type="number" suffix="%" color="grey-lighten-2" :readonly="readonly" @change="DataChange" />
                            </v-col>
                        </v-row>
                        <v-row no-gutters>    
                            <v-col cols="2">
                                <p class="mt-2 text-center">NOV</p>
                            </v-col>
                            <v-col cols="5">
                                <v-text-field v-model="detailItems.plan_nov" dense outlined hide-details type="number" suffix="%" color="grey-lighten-2" :readonly="readonly" @change="DataChange" />
                            </v-col>
                            <v-col cols="5">
                                <v-text-field v-model="detailItems.actual_nov" dense outlined hide-details type="number" suffix="%" color="grey-lighten-2" :readonly="readonly" @change="DataChange" />
                            </v-col>
                        </v-row>
                        <v-row no-gutters>    
                            <v-col cols="2">
                                <p class="mt-2 text-center">DEC</p>
                            </v-col>
                            <v-col cols="5">
                                <v-text-field v-model="detailItems.plan_dec" dense outlined hide-details type="number" suffix="%" color="grey-lighten-2" :readonly="readonly" @change="DataChange" />
                            </v-col>
                            <v-col cols="5">
                                <v-text-field v-model="detailItems.actual_dec" dense outlined hide-details type="number" suffix="%" color="grey-lighten-2" :readonly="readonly" @change="DataChange" />
                            </v-col>
                        </v-row>
                        
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>

<script>
import { readonly } from "vue";
import data_mapping_json from "../../json/sale_orders/project_information.json";

export default {
    data() {
        return {
            loading : false,
            readonly : this.ro,
            panel : [0],
            data: JSON.parse(JSON.stringify(this.dt)) || {},
            detailItems : {},
        };
    },

    props : ["ro", "dt"],
    methods: {
        DataChange() {
            for (let month in this.detailItems) {
                if ( this.detailItems[month] != null && 
                this.detailItems[month] !== "" && 
                !isNaN(this.detailItems[month]) &&
                this.detailItems[month] !== this.detailItems["year"]) {
                    this.detailItems[month] = parseFloat(this.detailItems[month]).toFixed(2)
                }
            }
            // console.log(this.detailItems)
            this.$emit("update-data", this.detailItems, "project_information");
        },
         PrepareData() {
            return new Promise(async (resolve, reject) => {
                let obj = {};
                for (let dt_json in data_mapping_json) {
                    if ( data_mapping_json[dt_json] != "") {
                        if (this.data[data_mapping_json[dt_json]] != null) {
                            obj[dt_json] = JSON.parse(
                                JSON.stringify(this.data[data_mapping_json[dt_json]])
                            
                            );
                        } else {
                            obj[dt_json] = null;
                        }
                    } else {
                        obj[dt_json] = null;
                    }
                }
                resolve(obj);
            });
        },
    },
    created() {
        this.loading = true;
        this.PrepareData().then((response) => {
            this.detailItems = response;
            this.loading = false;
        });
    },
}
</script>

<style lang="scss">
#header-text {
  font-size: 30px;
  display: inline-block;
}

@media (min-width: 0px) {
  .col.grid-5-custom {
    width: 100%;
    max-width: 100%;
    flex-basis: 100%;
  }
}

@media (min-width: 600px) and (max-width: 959px) {
  .col.grid-5-custom {
    width: 50%;
    max-width: 50%;
    flex-basis: 50%;
  }
}

@media (min-width: 960px) {
  .col.grid-5-custom {
    width: 20%;
    max-width: 20%;
    flex-basis: 20%;
  }
}
</style>